// src/loading.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var LoadingIcon = (props) => /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 200 200", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx("circle", { cx: "40", cy: "65", fill: "#3871FF", r: "15", stroke: "#3871FF", strokeWidth: "15", children: /* @__PURE__ */ jsx(
    "animate",
    {
      attributeName: "cy",
      begin: "-.4",
      calcMode: "spline",
      dur: "2",
      keySplines: ".5 0 .5 1;.5 0 .5 1",
      repeatCount: "indefinite",
      values: "65;135;65;"
    }
  ) }),
  /* @__PURE__ */ jsx("circle", { cx: "100", cy: "65", fill: "#3871FF", r: "15", stroke: "#3871FF", strokeWidth: "15", children: /* @__PURE__ */ jsx(
    "animate",
    {
      attributeName: "cy",
      begin: "-.2",
      calcMode: "spline",
      dur: "2",
      keySplines: ".5 0 .5 1;.5 0 .5 1",
      repeatCount: "indefinite",
      values: "65;135;65;"
    }
  ) }),
  /* @__PURE__ */ jsx("circle", { cx: "160", cy: "65", fill: "#3871FF", r: "15", stroke: "#3871FF", strokeWidth: "15", children: /* @__PURE__ */ jsx(
    "animate",
    {
      attributeName: "cy",
      begin: "0",
      calcMode: "spline",
      dur: "2",
      keySplines: ".5 0 .5 1;.5 0 .5 1",
      repeatCount: "indefinite",
      values: "65;135;65;"
    }
  ) })
] });

export {
  LoadingIcon
};
